// @flow

import React from 'react';
import type {Element} from 'react';
import type {ScheduledEpisode} from '../store';

export default function ScheduleEpisode({ episodeNumber, title, description, airings }: ScheduledEpisode): Element<any> {
  return <li key={episodeNumber} className="airing">
    <div className="airing-title body-large">
      #{episodeNumber} - {title}
    </div>
    <div className="airing-desc">
      {description}
    </div>
    <ul className="airdates">
      {
        airings.map(function(airing, i) {
          return <li key={i} className="airing-time">
            {airing.isNew && <span className="highlight-text"> New</span>} {airing.displayTime} <a href="/channels/" className="no-delay airing-channel">{airing.channel}</a>
          </li>;
        })
      }
    </ul>
  </li>;
};